import styled from "styled-components";
import theme from '../../styles/theme';


const StyledButton = styled.button`
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 8px;
    outline: 0 !important;
    border: 0 !important;
    margin: 0px 6px;
    width: calc(100% - 12px);
    height: 2.5rem;
    background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), ${theme.color.black[80]};
    border-radius: 8px;
    font-size: 1rem;
    line-height 24px;
    color: ${theme.color.white[80]};
    &:active{
        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.25);
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), ${theme.color.black[100]};
        color: ${theme.color.white[100]};
        // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
    &:hover{
        box-shadow: 0px 0px 0px rgba(0, 0, 0, 0.25);
        background: linear-gradient(0deg, rgba(255, 255, 255, 0.2), rgba(255, 255, 255, 0.2)), ${theme.color.black[100]};
        color: ${theme.color.white[100]};
        // box-shadow: 0px 4px 4px rgba(0, 0, 0, 0.25);
    }
    transition: all 50ms ease-in-out;
`;

const Button = (props) => {
    return (
        <StyledButton {...props} />
    )
}

export default Button;